import { CommunityApp } from '@atlassian/learning-components';
import { sendTrackEvent } from '../services/analytics';
import { getAnalyticsAnonymousId } from './utilities';

export const sendNewAccountEvent = async (isNewForumsProfile: boolean, userAccountId?: string) => {
  try {
    const articlePopupLoginClicked = window.sessionStorage.getItem('article_popup_login_clicked');
    if (articlePopupLoginClicked) {
      await sendTrackEvent(
        CommunityApp.HOME,
        'articlePopup',
        'signup',
        {
          isNewForumsProfile,
          anonymousId: getAnalyticsAnonymousId(),
          variant: articlePopupLoginClicked,
        },
        userAccountId,
      );
      window.sessionStorage.removeItem('article_popup_login_clicked');
    }
  } catch (error) {
    console.error('[sendNewAccountEvent] Error sending event:', error);
  }
};
